import { Box, Button, Stack, Typography } from "@mui/material";
import { useUnit } from "effector-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { deleteData } from "../api";
import Header from "../components/Header";
import { $playerData } from "../store";

const Settings = () => {
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [playerData] = useUnit([$playerData]);
  const hackneyId = playerData?.hackneyId;

  const onClickHandler = async () => {
    await deleteData();
    window.Telegram.WebApp.close();
    navigate("/");
  };

  const onCloneHandler = () => {
    if (hackneyId) {
      navigator.clipboard
        .writeText(hackneyId.toString())
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 2000);
        })
        .catch((err) => {
          console.error("Failed to copy:", err);
        });
    }
  };

  return (
    <Stack>
      <Header />
      <Stack
        height={"100dvh"}
        width={"100%"}
        bgcolor={"secondary.dark"}
        display={"flex"}
        justifyContent={"center"}
        alignContent={"center"}
      >
        <Typography width={"100dvw"} textAlign={"center"} pt={2}>
          Settings
        </Typography>
        <Typography width={"100dvw"} textAlign={"center"}>
          HackneyId : {playerData.hackneyId}
        </Typography>
        <Box display={"flex"} justifyContent={"center"} gap={2} mt={2}>
          <Button variant="blue" onClick={onCloneHandler}>
            {copied ? "Copied !" : "Copy HackneyId"}
          </Button>
          <Button variant="blue" onClick={onClickHandler}>
            Delete data
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
};

export default Settings;
